import TableViewNew from './TableViewNew';

// Export the TanStack Table version as the default
// The legacy implementation is preserved in TaskCategoryGroup.js for reference
export default TableViewNew;
